import {Inject, Injectable,} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiV0} from "./rest/api.v0";
import {YASC_REST_CONFIG, YascLibSettings, YascRestApiService} from '@yasc/yasc-material-components';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class RestApiService extends YascRestApiService {
    constructor(
        @Inject(YASC_REST_CONFIG) libSettings: YascLibSettings,
        http: HttpClient,
        cookieService: CookieService,
    ) {
        // @ts-ignore
        super(libSettings, http);
        this._v0 = new ApiV0(this, cookieService);
    }

    private readonly _v0: ApiV0;

    //private readonly _nationalHoliday: ApiNationalHolidays;

    get v0(): ApiV0 {
        return this._v0;
    }

    /*get nationalHoliday(): ApiNationalHolidays{
        return this._nationalHoliday;
    }*/
}
